;(function () {

"use strict";

var sendEmail = false;

var PageView = Backbone.View.extend({
  initialize: function () {
    console.log('init export page');
  },
  events: {
    'click .export': function (e) {
      if ($(e.target).hasClass('disabled')) { return; }

      var url = '/export/mail';
      var data = {};

      if ($('input.configuration-only').is(':checked')) {
        data['configuration_only'] = true;
      }

      if ($('input.link-to-file').is(':checked')) {
        data['link_to_file'] = true;
      }

      if (sendEmail) {
        if (this.$el.find('input.alt-email').val()) {
          data.email = this.$el.find('input.alt-email').val();
        }
      }

      $.get(url, data, function (d) {
        ShopifyApp.Modal.alert({
          title: "Export Started",
          message: "The export process has been started. This will take a few minutes. When it is completed, an email will be sent to the store owner containing the export file."
        });
        this.disabled = true;
        $("a.btn.export").addClass('disabled').attr('disabled', 'disabled').text('Running Export');
      });
  
      // ShopifyApp.flashNotice("Starting Export");
    },
    'change input[name="diff-email"]': function (e) {
      if ($(e.target).is(':checked')) {
        sendEmail = true;
        $(e.target).parent().parent().next().show();
      } else {
        sendEmail = false;
        $(e.target).parent().parent().next().hide();
      }
    }
  }
});

module.exports = PageView;

}());